<template>
  <div class="room-detail-tags" @click="submit($event)">
    <ul v-if="tags && tags.length" class="tags-list">
      <template v-for="(item,index) in tags">
        <li v-if="index < viewNum" :key="item.id">
          <img class="icon" :src="item.icon" :onerror="defaultImg"/>
          <div class="name">{{ getName(item.name) }}</div>
          <div class="common-clr"></div>
        </li>
        <li v-if="index === viewNum - 1" :key="item.id">
          <template v-if="isDetailTxt">
            <span v-if="tags && tags.length === 0" class="tags_text">查看详情</span>
            <img v-if="isDetail" class="tags_arrow"
                 :class="{'txt':tags && tags.length === 0}"
                 :src="`${imgUrl}/cruiseDetail/icons/icon-arrow-right.png`"/>
          </template>
        </li>
      </template>
    </ul>
    <template v-else>
      <div v-if="isDetailTxtCart" class="tags_box">
        <span v-if="tags && tags.length === 0" class="tags_text">查看详情</span>
        <img v-if="isDetail" class="tags_arrow"
             :class="{'txt':tags && tags.length === 0}"
             :src="`${imgUrl}/cruiseDetail/icons/icon-arrow-right.png`"/>
      </div>
    </template>
    <div class="common-clr"></div>
  </div>
</template>

<script>
export default {
  name: "DeviceFeatureTags",
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    isDetailTxt: {
      type: Boolean,
      default: true
    },
    isDetailTxtCart: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    viewNum: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
    }
  },
  computed: {
    defaultImg() {
      return "this.src = 'https://resource.rcclchina.com.cn/common/default/icon-default.png'"
    }
  },
  methods: {
    submit(e) {
      if(this.isDetail) {
        this.$emit('submit', e);
      }
    },
    getName(name) {
      return name.lastIndexOf('-') >= 0 ? name.substr(0, name.lastIndexOf('-')) : name;
    }
  }
}
</script>

<style lang="less" scoped>
.room-detail-tags {
  font-size: 12px;
  margin-top: 7px;
  & .tags-list {
    float: left;
    & > li {
      display: inline-block;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
      & > .icon {
        float: left;
        height: 11px;
        width: 11px;
        margin-right: 4px;
        margin-top: 2px;
      }
      & > .name {
        float: left;
        line-height: 14px;
        letter-spacing: -1px;
      }
      & .tags_text {
        float: left;
        margin-right: 5px;
        color: #0073bb;
      }
      & .tags_arrow {
        float: left;
        height: 8px;
        margin-bottom: 3px;
      }
      & .tags_arrow.txt {
        margin-top: 4px;
      }
    }
  }

  & .tags_box {
    display: flex;
    align-items: center;
    gap: 5px;
    & .tags_text {
      color: #0073bb;
    }
    & .tags_arrow {
      height: 8px;
    }
    //& .tags_arrow.txt {
    //  margin-top: 4px;
    //}
  }
}
</style>
